import React from "react";
import { isCompanyUser, useLoginContext } from "contexts/LoginContext/LoginContext";
import { faStar } from "@fortawesome/free-solid-svg-icons"; // Import FontAwesome icon
import ProfileCardBase from "./ProfileCardBase/ProfileCardBase";

const MyFavoritesCard: React.FC = () => {
  const { currentUser } = useLoginContext();

  if (isCompanyUser(currentUser) || !currentUser) return null;

  return (
    <ProfileCardBase
      title="Mine favoritter"
      actionText="Se favoritter"
      actionLink="/student-profile/my-favourites/"
      icon={faStar} // Pass the FontAwesome icon directly
    >
      Her kan du se stillingsannonser du har merket som favoritt.
    </ProfileCardBase>
  );
};

export default MyFavoritesCard;
